/**
 * The order in which the steps that can redirect are allowed to run after a session appears.
 *
 * Each of them navigates somewhere, so leaving them to race means the destination depends on whose
 * network response landed first. The chain is: stakeholder invitation and subscription offer, then
 * the data-room invitation, then the generic unfinished-company redirect — most specific
 * intent last, so it is the one that stands.
 */
export type AuthBootstrapFlags = {
  isAuthenticated: boolean;
  isDataRoomInviteHandled: boolean;
  isInvitationHandled: boolean;
  isOfferHandled: boolean;
  isUnfinishedCompanyHandled: boolean;
};

export const shouldAcceptDataRoomInvite = ({
  isAuthenticated,
  isDataRoomInviteHandled,
  isOfferHandled,
}: AuthBootstrapFlags): boolean => isAuthenticated && isOfferHandled && !isDataRoomInviteHandled;

export const shouldResolveUnfinishedCompany = ({
  isAuthenticated,
  isDataRoomInviteHandled,
  isInvitationHandled,
  isOfferHandled,
  isUnfinishedCompanyHandled,
}: AuthBootstrapFlags): boolean =>
  isAuthenticated &&
  isInvitationHandled &&
  isOfferHandled &&
  isDataRoomInviteHandled &&
  !isUnfinishedCompanyHandled;
